module.exports = __webpack_public_path__ + "static/san-francisco-d70f56f552bcc272fe87ab76cc5f8f9a.png";